import React from 'react'
import agent from '../agent'
import CommitUserList from './widgets/CommitUserList';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import Pager from 'react-pager'
import {
    ETH_COMMIT_USER_LIST_PAGE_LOADED,
    ETH_COMMIT_USER_LIST_PAGE_UNLOADED
} from '../constants/actionTypes'


const mapStateToProps = state => ({
    ...state.userList,
    appName: state.common.appName,
    token: state.common.token
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) => {
        dispatch({ type: ETH_COMMIT_USER_LIST_PAGE_LOADED, payload })
    },
    onUnload: () =>
        dispatch({ type: ETH_COMMIT_USER_LIST_PAGE_UNLOADED }),
});

class Users extends React.Component {
    constructor() {
        super();
    }
    componentWillMount() {
        const payload = agent.Users.getCommitUsers('eth')
        this.props.onLoad(payload);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }
    render() {
        return (
            <div class='pane'>
                <h1>ETH Direct Buying - User</h1>
                <CommitUserList users={this.props.users} loading={this.props.loading} type={'ethcommit'}/>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);



// WEBPACK FOOTER //
// ./src/components/EthCommitUsers.js